// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { toTenantUrl } from '../app/core/config/tenant';

const defaultTenant = 'us1';

export const environment = {
  production: false,
  DEFAULT_DEV_TENANT: defaultTenant,
  KEYCLOAK_TENANTS: ['us1', 'bpgh'],
  PRODUCT_NAME: 'fastr',
  CLIENT_ID: 'spa',
  REDIRECT_UI: toTenantUrl('https://TENANT.stage.fastr.ai/', defaultTenant),
  LOGOUT_URL: toTenantUrl('https://TENANT.stage.fastr.ai/', defaultTenant),
  API_BASE_URL: toTenantUrl('https://TENANT.stage.fastr.ai:443/api/private/fastr', defaultTenant),
  BRANDFETCH_CLIENT_ID: '1idohRgWlTB4dRMCLeY',
  KEYCLOAK_URL: 'https://auth.stage.fastr.ai/',
  AUTH0_DOMAIN: 'mojo-staging.auth0.com',
  AUTH0_CLIENT_ID: 'vDiTivtpFLtOA8ZK0SBxdIoK64hkOanJ',
  AUTH0_AUDIENCE: 'https://irp.stage.mojorank.com/',
  MS_CLIENT_ID: 'c50803ea-94aa-4067-939f-b3aff5ba1930',
  GM_CLIENT_ID: '927136947586-flkn7lv52hokihriblb6i4hi6rtstm89.apps.googleusercontent.com',
  GM_URL: 'https://accounts.google.com/o/oauth2/v2/auth',
  GM_TOKEN_URL: 'https://oauth2.googleapis.com/token',
};
